import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { EditGpuApi, getGPUbyId } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";

const EditGpu = () => {
  const navigate = useNavigate();
  let param = useParams();
  const gpu_id = param.p_id;
  const { userID } = useStateContext();
  const [formData, setFormData] = useState({
    part: "",
    gpu_name: "",
    specs: "",
    detail: "",
    box_qrscan: "",
    sku: "",
    box_id: "",
    lot_no: "",
    gpu_sn: "",
    other: "",
    note: "",
    recv_date: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const reqData = {
      user_id: userID,
      name: formData.gpu_name,
      specs: formData.specs,
      detail: formData.detail,
      box_qrscan: formData.box_qrcode,
      sku: formData.sku,
      box_id: formData.box_id,
      lot_no: formData.lot_no,
      gpu_sn: formData.gpu_sn,
      other: formData.other,
      notes: formData.note,
    };
    try {
      const response = await EditGpuApi(gpu_id, reqData);
      if (response.success) {
        showSuccessToast("Success!", "GPU Updated successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "GPUs failed to edit!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "GPUs did not update!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (!gpu_id) return;
      TimeoutUtility.resetTimeout();
      await getGPUbyId(gpu_id)
        .then((resp) => {
          setFormData({
            part: resp.data.part_number + " - " + resp.data.part_description,
            gpu_name: resp.data.name,
            specs: resp.data.specs,
            detail: resp.data.detail,
            box_qrscan: resp.data.box_qrcode,
            sku: resp.data.sku,
            box_id: resp.data.box_id,
            lot_no: resp.data.lot_no,
            gpu_sn: resp.data.gpu_sn,
            other: resp.data.other,
            note: resp.data.notes,
            recv_date: resp.data.recv_scan_date.slice(0, -1),
          });
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, [gpu_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="UPDATE GPU INFO" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={8} lg={12} className="container-col">
              <TextInputField
                label="Part:"
                name="part"
                value={formData.part}
                placeholder="Part"
                disabled
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Name:"
                  name="gpu_name"
                  value={formData.gpu_name}
                  onChange={handleChange}
                  placeholder="Name"
                  error={errors.gpu_name}
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  onChange={handleChange}
                  placeholder="Specs"
                  error={errors.specs}
                />
                <TextAreaField
                  label="Detail:"
                  name="detail"
                  value={formData.detail}
                  onChange={handleChange}
                  placeholder="Detail"
                  error={errors.detail}
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={formData.recv_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextAreaField
                  label="Box QR Scan:"
                  name="box_qrscan"
                  value={formData.box_qrscan}
                  placeholder="Box QR Scan"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
                <TextInputField
                  label="Box ID:"
                  name="box_id"
                  value={formData.box_id}
                  placeholder="Box ID"
                  disabled
                />
                <TextInputField
                  label="Lot #:"
                  name="lot_no"
                  value={formData.lot_no}
                  placeholder="Lot #"
                  disabled
                />
                <TextInputField
                  label="GPU SN:"
                  name="gpu_sn"
                  value={formData.gpu_sn}
                  onChange={handleChange}
                  placeholder="GPU SN"
                  error={errors.gpu_sn}
                  compulsory={true}
                  disabled
                />
                <TextInputField
                  label="Other:"
                  name="other"
                  value={formData.other}
                  onChange={handleChange}
                  placeholder="Other"
                  error={errors.other}
                />
                <TextAreaField
                  label="Note:"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  placeholder="Note"
                  error={errors.note}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditGpu;
